function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@chakra-ui/react";
import { keyframes } from "@emotion/react";
import { corePalette } from "../theme/index";
const spin = keyframes`
	100% {
		transform: rotate(360deg);
	}
`;
export const LoadingSpinner = (_param)=>{
    var { thickness = 4, size = 32, trackColor = corePalette.neutral['20'], thumbColor = corePalette.neutral['100'], speed = 600 } = _param, boxProps = _object_without_properties(_param, [
        "thickness",
        "size",
        "trackColor",
        "thumbColor",
        "speed"
    ]);
    return /*#__PURE__*/ _jsx(Box, _object_spread({
        animation: `${spin} ${speed}ms infinite linear`,
        borderColor: trackColor,
        borderRadius: "50%",
        borderStyle: "solid",
        borderTopColor: thumbColor,
        borderWidth: `${thickness}px`,
        display: "inline-block",
        height: `${size}px`,
        width: `${size}px`
    }, boxProps));
};

//# sourceMappingURL=LoadingSpinner.js.map